import clsx from 'clsx';

import { Skeleton } from '../Skeleton';

/**
 * Skeleton for a chart.
 */
export function ChartSkeleton(props: { height?: number; className?: string }) {
    const { height = 320, className } = props;

    return (
        <div className={clsx('flex flex-col', className)}>
            <div className="mx-6 mt-6 flex flex-row items-end gap-3" style={{ height }}>
                <Skeleton className="size-8 h-full" />
                <Skeleton className="size-8 h-[80%]" />
                <Skeleton className="size-8 h-[60%]" />
                <Skeleton className="size-8 h-[80%]" />
                <Skeleton className="size-8 h-[40%]" />
                <Skeleton className="size-8 h-[20%]" />
                <Skeleton className="size-8 h-[60%]" />
                <Skeleton className="size-8 h-[80%]" />
                <Skeleton className="size-8 h-[60%]" />
                <Skeleton className="size-8 h-[40%]" />
                <Skeleton className="size-8 h-[20%]" />
                <Skeleton className="size-8 h-full" />
                <Skeleton className="size-8 h-[80%]" />
                <Skeleton className="size-8 h-[60%]" />
                <Skeleton className="size-8 h-[80%]" />
                <Skeleton className="size-8 h-[40%]" />
                <Skeleton className="size-8 h-[20%]" />
                <Skeleton className="size-8 h-[60%]" />
                <Skeleton className="size-8 h-[80%]" />
                <Skeleton className="size-8 h-[60%]" />
                <Skeleton className="size-8 h-[40%]" />
                <Skeleton className="size-8 h-[20%]" />
            </div>
            <div className="flex h-6 flex-row items-end justify-center">
                <Skeleton className="h-4 w-20" />
            </div>
        </div>
    );
}
